<template>
  <div >
<nav class="navbar navbar-expand-lg ">
    <div style="padding-left: 0px;" class="container-fluid ">

<div class="navbar-nav">
              <a><img class="pfimg2 hiden1"  src="" alt="" width="100" height="" ></a>


  <div  @mouseleave="my1">
    
              <a @mouseenter="my1" @click="my1" ref="myButton" v-b-toggle.sidebar-1 type="button" class="nav-link "  id="navbarDropdownMenuLink" role="button" >
              <span class="menu1" >{{language[0]['Menu']}}</span>
              </a>


    <b-sidebar  bg-variant="primary"  id="sidebar-1" title=""  shadow>
<template #title >
    <!-- Custom title content -->
    <img class="ms-4"  src="./../../public/img/logo-even.png" width="140px" alt="Evenware Logo">
  </template>
    <div >
  <br>
    <ul class="list-unstyled ps-0">
      <li class="mb-1 bodr1"  >
        <a  type="button"  class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/dashboard/index">{{language[136]['Dashboard']}} </router-link></a>
       
        </li>

      <li  class="mb-1 bodr1" >
        <a  type="button"  v-b-toggle.issue2 class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span  class="router2" >{{language[3]['Issue Tracking']}}</span></a>
        <b-collapse class="mrgin1" id="issue2">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/issuetracking/index">{{language[4]['Manage Issue']}} </router-link></a>
                    </li>
                    <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/contractors/index">{{language[5]['Manage Contractor']}} </router-link></a>
                    </li>
                    <!-- <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/issuetracking/create"><b>Create Issue</b> </router-link></a>
                    </li> -->
                   
          
                   
          </ul>
        </b-collapse>
        
      </li>



      

      

      

      

      

   
      
      <li class="mb-1 bodr1"  >
        <a  type="button"  v-b-toggle.users class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" >{{language[6]['Users']}}</span></a>
        <b-collapse class="mrgin1" id="users">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/user/index">{{language[7]['Manage Users']}}</router-link></a>
                    </li>
          </ul>
          </b-collapse>
        </li>


          
      <li class="mb-1 bodr1"  >
        <a  type="button"  v-b-toggle.setting class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" >{{language[8]['Settings']}}</span></a>
        <b-collapse class="mrgin1" id="setting">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/category/index">{{language[106]['Manage Category']}} </router-link></a>
                    </li>
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/message/index"> {{language[140]['Default Message']}}</router-link></a>
                    </li>
            


      <li class="mb-1 "  >
        <a  type="button"  v-b-toggle.settingsub class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" >{{language[82]['Language']}}</span></a>
        <b-collapse class="mrgin1" id="settingsub">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/setting/default">{{language[72]['Set Default']}}</router-link></a>
                    </li>
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/setting/index">{{language[9]['Manage Language']}}</router-link></a>
                    </li>

          </ul>
          </b-collapse>
        </li>

       
          </ul>
          </b-collapse>
        </li>


        

       


        <li class="mb-1 bodr1"  >
        <a  type="button"  v-b-toggle.usermanual class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><span class="router2" >{{language[128]['User Manual']}}</span></a>
        <b-collapse class="mrgin1" id="usermanual">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1">
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/usermanual/indexmobile">MobilApp Användar Manual</router-link></a>
                    </li>
                  <li>
                      <a class="link-dark d-inline-flex text-decoration-none rounded bodr2 clr3"><router-link class="router2" to="/usermanual/index">Skrivbordsapplikation Manual </router-link></a>
                    </li>

          </ul>
          </b-collapse>
        </li>

       
          </ul>
          </b-collapse>
        </li>

    
     


     

      








    </ul>
      </div>
      
    </b-sidebar>


  </div>

</div>



<div class="d-flex">
 
  <a style="color: #1b2753;" class="nav-link" href="" v-on:click="Logout()"> {{language[2]['Logout']}}({{user}}) </a>

</div>

      
        
    
     
     
    </div>
    
  </nav>
  
</div>
  
</template>
<script>
 import authService from '@/auth.service';
 import axios from 'axios';
 import httpClient from '@/axios';
  export default {
   
    data () {
      return {
     
        activeNotifications: false,
        language:JSON.parse(authService.isLanguage()),
      }
    },
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    beforeMount(){
        this.user = authService.isUsername(); 
      },
      mounted() {
    
      },
  
    methods: {
      Logout() {
          console.log(this.access_token);
          httpClient.get('http://localhost/Skygarden_vuejs/web/api/user/logout',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          }).then(
           response => {
             
             console.log(response);
          }
           
          ),
          authService.Logout();
        },
        
      my1(){
   
      this.$refs.myButton.click()

      },
      my2(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton2.click()
        }
   

      },
      my3(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton3.click()
        }
   

      },
      my4(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton4.click()
        }
   

      },
      my5(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton5.click()
        }
   

      },
      my6(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton6.click()
        }
   

      },
      my7(){
        if(window.innerWidth > 600){
         
          this.$refs.myButton7.click()
        }
   

      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      }
    }
  }

</script>
<style >

.bg-primary{
  background-color: rgb(229, 232, 236) !important;
}

.router2{
  text-decoration: none;
  color: white;
  
}
.router2:hover{
  color: white;
}
.b-sidebar{
  width: 250px !important;
}
.mrgin1{
      margin-left: 15px;       
}
.clr3:hover{
  background-color: #2642a7  !important;
  width: 100% !important;
  color: white;
}
.clr3:focus{
  background-color: #2642a7 !important;
  width: 100%;
  color: white  !important; 
}

.bodr2{
  
  padding: 10px;
}
.bodr1{
  border-bottom: 2px #2642a7 solid;
  padding: 5px;
}
   .navbar{
padding-left: 0px !important;
padding-right: 0px !important;
   }
     
      .menu1{
          color: #1b2753;
          border: 2px #1b2753  solid; 
          padding: 8px 5px 10px 5px;
          border-radius: 15px;
          margin-left: 5px;
         
        }
        .menu1:hover{
          border: 4px #1b2753  solid; 
         
        }
        .clr1{
          background-color: #AED8F2 !important;
          height:2000px !important;
          margin-left: -10px;
      
        }
      
        .bdr3{
         border-top: 2px #E4E5E6  solid;
         padding-bottom: 11px;
        }
        .shadow1 {
        /* border: 1px solid; */
        padding: 10px;
        /* box-shadow: 3px 6px 3px #bdbbbb; */
        }
      
        .click1:hover{
       
        background-color: blue;
        }
        .pf1{
          margin-right: 13px;
          margin-top: 3px;
        }
        .logout1{
          margin-right: 10px;
        }
        .pfimg2{
         
         margin-top: 4px;
         
         
        }
        .bel1{
          margin-right: 30px;
          margin-top: 8px;
        }
        .badge1 {
        position: absolute;
        top: -4px;
        right: 3px;
        padding: 1px 5px;
        border-radius: 50%;
        background-color: red;
        color: white;
        font-size: 10px !important;
   
        }
        .icon1{
          border-radius: 13px;
        }
        .router1{
          text-decoration: none;
        }
        .b-sidebar > .b-sidebar-body {
          background-color: #1b2753 !important;
        }
        .b-sidebar > .b-sidebar-header {
          background-color: #1b2753 !important;
          border-top-right-radius: 15px !important;
        }

        .b-sidebar {
          border-top-right-radius: 15px !important;
        }
        .b-sidebar > .b-sidebar-body {
          border-bottom-right-radius: 15px !important;
        }

        
  </style>
